import moment from "moment";
import {DATE_FORM_FORMAT} from "@/constants/date";

// postback.createdAt is stored in UTC+6, so "today" must be taken from the same calendar
export const POSTBACK_UTC_OFFSET = 360

export const postbackToday = () => moment().utcOffset(POSTBACK_UTC_OFFSET).format(DATE_FORM_FORMAT)

export const defaultFilters = () => ({
  pagination: {
    limit: 20,
    page: 1,
  },
  filter: {
    advertiser: {
      id: {
        value: '',
        operator: 'in'
      }
    },
    postbackPartner: {
      id: {
        value: '',
        operator: 'in'
      }
    },
    trafficSource: {
      id: {
        value: '',
        operator: 'in'
      }
    },
    createdAt: {
      value: `${postbackToday()} 00:00:00|${postbackToday()} 23:59:59`,
      operator: 'bwn',
    },
    event: {
      value: '',
      operator: 'in'
    },
    clickId: {
      value: '',
      operator: 'like',
    },
    innerClickId: {
      value: '',
      operator: 'like',
    },
    transactionId: {
      value: '',
      operator: 'like',
    },
    player: {
      value: '',
      operator: 'in',
      outerId: {
        value: '',
        operator: 'like',
      },
    },
    offerPartnerLanding: null,
    retargeting: {
      value: '',
      operator: 'in',
    },
  },
  sortBy: ['id'],
  sortDesc: [true],
  clientOptions: {
    filterPanelExpanded: false,
  },
})
